import { render, staticRenderFns } from "./Transits.vue?vue&type=template&id=3c48177e"
import script from "./Transits.vue?vue&type=script&lang=js"
export * from "./Transits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports